import { StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { createWithEqualityFn as create } from 'zustand/traditional'

import { base as baseConfig } from '@/config'

import { sentryStore } from '../sentryStore'
import { signUpStore } from '../signUpStore'
import { RootState, SentryState, SignUpState } from '../types'

const KEY = 'store'
const rootStore: StateCreator<RootState> = (...args) => ({
  ...signUpStore(...args),
  ...sentryStore(...args),
})

export const useStore = baseConfig.isProduction
  ? create<RootState, [['zustand/persist', SignUpState | SentryState]]>(persist(rootStore, { name: KEY }))
  : create<RootState, [['zustand/devtools', never], ['zustand/persist', SignUpState | SentryState]]>(
      devtools(persist(rootStore, { name: KEY }))
    )
